module.exports = __webpack_public_path__ + "img/3.2f622c0f.png";